import { Drawer as BaseUIDrawer } from "@base-ui/react/drawer";
import { cn } from "@/lib/utils";
import { resolveRelationshipId } from "@/lib/utils/theme-configuration-class";
import { CardVariant } from "../card";

export interface DrawerProps {
	children: React.ReactNode;
	trigger: React.ReactElement;
	close?: React.ReactNode;
	title?: string;
	className?: string;
	variant?: CardVariant;
}

export const Drawer: React.FC<DrawerProps> = ({ children, title, trigger, close, variant = "default" }) => {
	return (
		<BaseUIDrawer.Root>
			<BaseUIDrawer.Trigger render={trigger} />

			<BaseUIDrawer.Portal>
				<BaseUIDrawer.Backdrop className="[--backdrop-opacity:0.2] [--bleed:3rem] fixed z-1000 inset-0 min-h-dvh bg-black opacity-[calc(var(--backdrop-opacity)*(1-var(--drawer-swipe-progress)))] transition-opacity duration-450 ease-[cubic-bezier(0.32,0.72,0,1)] data-swiping:duration-0 data-ending-style:opacity-0 data-starting-style:opacity-0 data-ending-style:duration-[calc(var(--drawer-swipe-strength)*0.4s)] supports-[-webkit-touch-callout:none]:absolute" />

				<BaseUIDrawer.Viewport className="fixed z-1000 inset-0 flex items-end justify-center">
					<BaseUIDrawer.Popup
						className={cn(
							"ms-card ms-card-" + resolveRelationshipId(variant),
							"-mb-12 w-full max-h-[calc(80vh+3rem)] rounded-t-2xl px-6 pb-[calc(1.5rem+env(safe-area-inset-bottom,0)+3rem)] pt-4 text-gray-900 outline outline-gray-200 overflow-y-auto overscroll-contain touch-auto transform-[translateY(var(--drawer-swipe-movement-y))] transition-transform duration-450 ease-[cubic-bezier(0.32,0.72,0,1)] data-swiping:select-none data-ending-style:transform-[translateY(calc(100%-3rem))] data-starting-style:transform-[translateY(calc(100%-3rem))] data-ending-style:duration-[calc(var(--drawer-swipe-strength)*0.4s)]",
						)}
					>
						<div className="w-12 h-1 mx-auto mb-4 rounded-full bg-(--ms-card-border-color)" />

						<BaseUIDrawer.Content className="mx-auto w-full max-w-lg">
							{title && <BaseUIDrawer.Title className="mb-1 text-lg font-medium text-center">{title}</BaseUIDrawer.Title>}
							<BaseUIDrawer.Description className="mb-6 text-base text-center">{children}</BaseUIDrawer.Description>

							{close && <BaseUIDrawer.Close className="w-full">{close}</BaseUIDrawer.Close>}
						</BaseUIDrawer.Content>
					</BaseUIDrawer.Popup>
				</BaseUIDrawer.Viewport>
			</BaseUIDrawer.Portal>
		</BaseUIDrawer.Root>
	);
};
